import XLogo from "./XLogo";
import { scrollToId } from "@/data/content";

const LINKS = [
  ["Showcase", "showcase"],
  ["About", "about"],
  ["Services", "services"],
  ["Terminal", "terminal"],
  ["Risk", "risk"],
  ["Advisory", "advisory"],
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-surface">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="flex flex-col justify-between gap-10 lg:flex-row">
          <div className="max-w-md">
            <div className="flex items-center gap-3">
              <XLogo size={40} />
              <span className="font-display text-3xl font-black uppercase tracking-[0.15em] text-ink">
                Team<span className="text-brand">&nbsp;X</span>
              </span>
            </div>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-dim">
              Global Investment Education & Executive Intelligence
            </p>
            <p className="mt-5 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-dim">
              <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-up" />
              Systems Operational — Node US-EAST
            </p>
          </div>
          <nav className="grid grid-cols-2 gap-x-16 gap-y-3 sm:grid-cols-3">
            {LINKS.map(([label, id]) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToId(id)}
                className="text-left font-mono text-[11px] uppercase tracking-[0.22em] text-mute transition-colors hover:text-brand"
              >
                {label}
              </button>
            ))}
          </nav>
        </div>

        <div className="mt-12 space-y-4 border-t border-line pt-8">
          <p className="text-xs leading-relaxed text-dim">
            TEAM X is an independent educational and consulting platform. Tesla
            and other company names mentioned on this website are used solely
            for informational and educational purposes. TEAM X is not affiliated
            with, endorsed by, or sponsored by Tesla, Inc. or any other featured
            company.
          </p>
          <p className="text-xs leading-relaxed text-dim">
            Nothing on this website constitutes financial, investment, legal, or
            tax advice. Information provided is for educational and
            informational purposes only. Investing involves risk, including the
            possible loss of principal. Users are solely responsible for their
            investment decisions.
          </p>
          <p className="pt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-dim">
            © {new Date().getFullYear()} TEAM X. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
